import { isNodeSelection, posToDOMRect } from "@tiptap/core"

import type { Editor } from "@tiptap/core"

// Tiptap's bubble menu keeps the positions of the update that opened it, and
// tippy asks again on scroll; after the doc shrinks those positions throw.
export function liveSelectionRect(editor: Editor): () => DOMRect {
	return () => {
		if (editor.isDestroyed) return new DOMRect()
		const { view, state } = editor
		const size = state.doc.content.size
		const { ranges } = state.selection
		const clamp = (pos: number) => Math.min(Math.max(pos, 0), size)
		const from = clamp(Math.min(...ranges.map((range) => range.$from.pos)))
		const to = clamp(Math.max(...ranges.map((range) => range.$to.pos)))

		if (isNodeSelection(state.selection)) {
			const node = view.nodeDOM(from) as HTMLElement | null
			if (node) {
				const wrapper = node.dataset?.nodeViewWrapper
					? node
					: node.querySelector?.("[data-node-view-wrapper]")
				const target = wrapper
					? (wrapper.firstChild as HTMLElement | null)
					: node
				if (target) return target.getBoundingClientRect()
			}
		}
		return posToDOMRect(view, from, to)
	}
}
